export class MissionsApiProvider {
  constructor(apiClient) {
    this.apiClient = apiClient;
  }

  /**
   * @param {number} missionId
   * @returns UserMissionProgress object
   */
  async getMission(missionId) {
    const requestUrl = `/missions/${missionId}`;
    return await this.apiClient.fetch(requestUrl);
  }

  async refreshMissionTask(missionId) {
    const requestUrl = `/missions/${missionId}/refresh`;
    return await this.apiClient.fetch(requestUrl, {
      method: "POST",
    });
  }
}
